import { Images } from '@/assets';
import { fonts } from '@/theme/fonts';
import React from 'react';
import styled from 'styled-components';
import SelectList from '../select/SelectList';
import { KeywordItemType } from '@/api/type/commonTypes';
import { useTranslation } from 'react-i18next';

interface CommonSearchProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClickSearch: () => void;
  onClickReset: () => void;
  options: KeywordItemType[];
  onSelect: (item: KeywordItemType) => void;
  selectedOption: KeywordItemType;
}
const CommonSearch = ({
  value,
  onChange,
  onClickSearch,
  onClickReset,
  options,
  onSelect,
  selectedOption,
}: CommonSearchProps) => {
  const { t } = useTranslation();
  return (
    <Container>
      <SelectList
        options={options}
        onSelect={onSelect}
        selectedOption={selectedOption}
      />
      <InputSection>
        <InputWrap>
          <Input
            value={value}
            onChange={onChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onClickSearch();
              }
            }}
          />
        </InputWrap>
        <ButtonsSection>
          <ButtonWrap>
            <SearchIconBtn onClick={onClickSearch} />
            <RefreshIcon onClick={onClickReset} />
          </ButtonWrap>
        </ButtonsSection>
      </InputSection>
    </Container>
  );
};

export default CommonSearch;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
`;

const InputSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const InputWrap = styled.div`
  border-radius: 20px;
  border: 3px solid #7299f7;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 15px 5px 20px;
  width: 423px;
  height: 41px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Input = styled.input`
  outline: none;
  border: none;
  height: 100%;
  flex: 1;
`;

const SearchIconBtn = styled.button`
  background-image: url(${Images.SearchIcon});
  width: 29px;
  height: 29px;
`;

const ButtonsSection = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;
`;

const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const RefreshIcon = styled.button`
  background-image: url(${Images.RefreshIcon});
  background-size: contain;
  width: 23px;
  height: 19px;
`;
